import { Laptop, Printer, Smartphone, Tablet, type LucideIcon } from "lucide-react";

const DEVICE_ICONS: Record<string, LucideIcon> = {
    computer: Laptop,
    smartphone: Smartphone,
    tablet: Tablet,
    printer: Printer,
};

export function getDeviceIcon(code: string): LucideIcon | undefined {
    return DEVICE_ICONS[code];
}
